import React from "react";
import type { WorkOrderWithAppointments } from "@myapp/contract";
import { ContactAttemptsCard, useContactAttempts } from "../../../../features/work-order-status";

interface Props {
  workOrderId: string;
  workOrder: WorkOrderWithAppointments;
  canEdit: boolean;
}

/**
 * Binds the card to its controller. A component of its own because the controller is a hook and
 * the page only has a work order once it has loaded — here the work order is always there.
 */
export const ContactAttemptsSection: React.FC<Props> = ({ workOrderId, workOrder, canEdit }) => {
  const controller = useContactAttempts({ workOrderId, workOrder, canEdit });
  return <ContactAttemptsCard controller={controller} />;
};
